var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"top-footer-button",class:{ isPC: _vm.$store.getters['camera/isPC'] }},[_c('div',{staticClass:"fixed-button"},[_c('FooterButton',{attrs:{"enabled":_vm.enabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }